export enum AddressVerificationField {
  BUILDING = 'building',
  STREET = 'street',
  UNIT = 'unit',
  CITY = 'city',
  POSTAL_CODE = 'postalCode',
}

export type AddressVerificationState = Record<
  `${AddressVerificationField}`,
  string
>;

export type AddressVerificationProps = {
  onVerified?: () => void;
};
